export default __webpack_public_path__ + "static/media/keto_monitor_health@2x.afa58a72.jpg";